import React from "react";
import TrackOrder from "components/track-order";
import { useDineIn } from "modules/dine-in/hooks";

const DineInTrackOrder = (props) => {
  const { goToLogin, goToSettings, goBack } = useDineIn();

  return (
    <TrackOrder goBack={goBack} goToLogin={goToLogin} goToSettings={goToSettings} />
  );
}

export default DineInTrackOrder;
